export const NUM_RESULTS_FOR_PAGE = 50
